module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-21.874f69af.png";